import { makeStyles } from "@mui/styles";
// import { commonStyles } from "../../theme/globalStyles";
import {
  LEFT_IMAGE,
  // LOGIN_BACKGROUND,
  RIGHT_IMAGE,
} from "../../utils/constants/assets";
import {
  SCROLL_BAR,
  fontSize,
  fontWeight,
} from "../../utils/constants/UI/uiConstants";
import { BRAND, GREY } from "../../utils/constants/colors";
import { commonStyles } from "../../theme/globalStyles";
import { BORDER } from "../../utils/colors";

export const styles = makeStyles({
  LINEAR: {
    minHeight: "1.5rem",
    marginTop: "1rem",
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gridTemplateColumns: "3fr 2fr",
    // backgroundSize: "300px",
    ...SCROLL_BAR,
    height: "100vh",
    background: `url(${LEFT_IMAGE}) right top no-repeat ,url(${RIGHT_IMAGE}) left bottom no-repeat`,
    flexDirection: "column",
    // ...TABLE_SCROLL_BAR,
    "@media (min-width: 480px)(max-width: 768px)": {
      display: "flex",
      flexDirection: "column",
      backgroundSize: "300px",
      backgroundColor: BRAND.PRIMARY,
    },
  },
  leftContainer: {
    width: "21.875vw",
    display: "flex",
    flexDirection: "column",
    paddingTop: "100px",
  },

  hovering: {
    "& :hover": {
      color: BRAND.PRIMARY,
    },
  },
  top: {
    paddingTop: "60px",
  },
  tops: {
    paddingTop: "4px",
    paddingBottom: "32px",
  },
  topp: {
    paddingTop: "32px",
  },
  socialAuthIcon: {
    height: "clamp(1.4rem,1.2vh,2.5rem)",
    marginRight: "12px",
    objectFit: "contain",
    width: "clamp(1.4rem,1.7vw,3.5rem)",
  },
  Gap: {
    display: "flex",
    padding: "20px 0px 0px 0px",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: "16px",
  },
  Border: {
    width: "23vw",
    borderTop: `1px solid ${BORDER.LIGHT}`,
  },
  Gapped: {
    display: "flex",
    padding: "20px 0px 0px 0px",
    width: "100%",
    gap: "16px",
    paddingTop: "24px",
    paddingBottom: "12px",
  },
  WiDTH: {
    width: "100%",
  },
  WiDTHs: {
    width: "100%",
    padding: "12px 0px",
  },
  FOUR: {
    paddingBottom: "4px",
  },
  FOURs: {
    paddingBottom: "4px",
    paddingTop: "12px",
  },
  Gaps: {
    display: "flex",
    width: "100%",
    gap: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
  },
  containLoginBtn: {
    paddingTop: "24px",
    display: "flex",
    justifyContent: "center",
  },
  contains: {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    height: "50vh",
    padding: "1rem",
  },
  containPolicy: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  termsPara: {
    fontSize: fontSize.XS,
    color: "#626B7E",
    fontFamily: "inter_400",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  TypoHead: {
    marginLeft: "0.2rem",
  },

  privacyLink: {
    fontSize: fontSize.XS,
    fontWeight: fontWeight.REGULAR,
    // lineHeight: "18px",
    // fontFamily: "inter_500",
    textDecoration: "none",
    paddingLeft: "4px",
    whiteSpace: "nowrap",
    color: GREY.SECONDARY,
    transition: "100ms",
    "&:hover": {
      color: BRAND.PRIMARY,
    },
  },
  socialAuthBtns: {
    fontFamily: "Roboto",
    background: "white",
    fontWeight: fontWeight.BOLD,
    border: "1px solid #E6E6E6",
    boxShadow:
      " 0px 3px 4px rgba(24, 24, 28, 0.04), 0px 1px 1px rgba(24, 24, 28, 0.04)",
    height: "40px",
    display: "flex",
    alignItems: "center",
    // fontFamily: "inter_400",
    fontSize: fontSize.SM,
    borderRadius: "6px",
    width: "100%",
    padding: "15px",
    justifyContent: "center",
    color: GREY.PRIMARY,
    cursor: "pointer",
    marginBottom: "12px",
  },
  socialAuthBtn: {
    fontFamily: "Roboto",
    background: "white",
    fontWeight: fontWeight.BOLD,
    border: "1px solid #E6E6E6",
    boxShadow:
      " 0px 3px 4px rgba(24, 24, 28, 0.04), 0px 1px 1px rgba(24, 24, 28, 0.04)",
    height: "40px",
    display: "flex",
    alignItems: "center",
    // fontFamily: "inter_400",
    fontSize: fontSize.SM,
    borderRadius: "6px",
    width: "100%",
    padding: "15px",
    justifyContent: "center",
    color: GREY.PRIMARY,
    cursor: "pointer",
  },

  //SignUpScreen css

  //GoogleSignupScreen
  containLogo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  logo: {
    // width: "clamp(80px,10vw,200px)",
    // height: "clamp(80px,10vh,200px)",
    objectFit: "contain",
  },

  //Not used css

  Cursor: {
    marginLeft: "0.3rem",
    cursor: "pointer",
  },

  // Gap: {
  //   padding: "20px 0px ",
  //   display: "flex",
  //   alignItems: "center",
  //   columnGap: "20px",
  // },

  nameFieldsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },

  title: commonStyles.largeTitle,
  para: commonStyles.largePara,
  iconPara: {
    fontFamily: "inter_300",
    color: "#212833",
    alignSelf: "center",
    fontSize: "clamp(0.9rem,1vw,2.7rem)",
  },
  eachIconContainer: {
    display: "flex",
  },
  iconsContainer: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "0.5rem",
  },
  analyticsImage: {
    // width: "75%",
    // height: "90%",
    objectFit: "contain",
    marginTop: "1rem",
    "@media (max-width: 1500px)": {
      width: "90%",
    },
  },
  containAnalyticsImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  reachIqTitle: {
    fontFamily: "inter_700",
    color: "#212833",
    alignSelf: "center",
    fontSize: "clamp(0.9rem,1.4vw,2.7rem)",
  },

  // emailSignIn: {
  //   color: "#ABB4BD",
  //   fontWeight: "400",
  //   fontSize: "clamp(0.8rem,0.8vw,2.4rem)",
  //   textAlign: "center",
  //   position: "relative",
  //   whiteSpace: "nowrap",
  // },

  Head: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.8rem",
    gap: "16px",
    paddingTop: "12px",
  },

  emailSignIn: {
    color: "#ABB4BD",
    fontFamily: "inter_400",
    fontSize: "clamp(12px, 0.729vw, 30px)",
    textAlign: "center",
    position: "relative",
  },
  signInSpan: {
    background: "white",
    zIndex: 2,
    padding: "0 5px",
    "&:after": {
      content: "''",
      position: "absolute",
      width: "100%",
      borderBottom: "1px solid #ddd",
      top: "55%",
      left: 0,
      zIndex: -1,
    },
  },
  containEmailSignIn: {
    padding: "20px 0",
  },
  containEachInput: {
    background: "#fcfcfd",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "0.5rem 1rem",
    border: "1px solid #D3DAE3",
    borderRadius: "8px",
    marginTop: "1rem",
  },
  eachInput: {
    border: "none",
    background: "#fcfcfd",
    fontFamily: "inter_500",
    fontSize: "clamp(14px,1vw,42px)",
    width: "100%",
  },
  domainInput: {
    border: "none",
    background: "#fcfcfd",
    fontFamily: "inter_500",
    fontSize: "clamp(14px,1vw,42px)",
    width: "100%",
    padding: "6px 8px",
    borderRadius: "5px 0px 0 5px",
  },
  domainText: {
    color: "#495057",
    alignSelf: "center",
    padding: " 0.6rem",
    height: "100%",
    fontFamily: "inter_500",
    fontSize: "14px",
    borderLeft: "1px solid #d3dae3",
  },
  containDomainInput: {
    display: "flex",
    position: "relative",
    paddingTop: "4px",
  },
  eachInputTitle: {
    color: "#ABB4BD",
    fontFamily: "inter_400",
    fontSize: "clamp(14px,0.8vw,42px)",
  },
  containForgotPassword: {
    display: "flex",
    justifyContent: "flex-end",
  },
  forgotPassword: {
    border: "none",
    color: "#ff4848",
    background: "white",
    fontFamily: "inter_400",
    fontSize: "clamp(14px,1vw,42px)",
    cursor: "pointer",
  },
  loginBtn: commonStyles.redButtonWithShadow,
  flex: {
    display: "flex",
    justifyContent: "center",
  },
  noAccountText: {
    color: "#6E6D7A",
    fontFamily: "inter_400",
    fontSize: "clamp(14px,1vw,42px)",
    cursor: "pointer",
  },
  authToggle: {
    border: "none",
    color: "#ff4848",
    background: "unset",
    fontFamily: "inter_400",
    fontSize: "clamp(14px,1vw,42px)",
    cursor: "pointer",
  },
  containPasswordInput1: {
    background: "#fcfcfd",
    padding: "0.5rem ",
    border: "1px solid #D3DAE3",
    borderRadius: "8px",
    width: "95%",
    marginTop: "1rem",
  },
  containPasswordInput2: {
    background: "#fcfcfd",
    border: "1px solid #D3DAE3",
    borderRadius: "8px",
    width: "99%",
    padding: "0.5rem",
    marginTop: "1rem",
  },

  subDomainText: {
    position: "absolute",
    right: "14px",
    // top: "45%",
    top: "25%",
    color: "#102F51",
    fontFamily: "inter_400",
    fontSize: "clamp(12px, 0.729vw, 30px)",
  },

  privacyLinkSeperatorText: {
    fontSize: "12px",
    fontWeight: "500",
    textDecoration: "none",
    paddingLeft: "4px",
    whiteSpace: "nowrap",
    color: "#626B7E",
  },
  inputLabelText: {
    fontFamily: "inter",
    fontStyle: "normal",
    fontSize: "clamp(12px, 0.729vw, 24px)",
    fontWeight: "500",
    marginBottom: "4px",
    color: "#212833",
  },
});
